export const ukTranslations = {
  // Navigation
  'nav.title': 'Smart Café',
  'nav.portal': 'Портал',
  'nav.table': 'Столики',
  'nav.kitchen': 'Кухня',
  'nav.admin': 'Адмін',
  'nav.portalAdmin': 'Адмін порталу',
  'nav.orders': 'Замовлення',

  // Table Screen
  'table.header.label': 'Термінал замовлень',
  'table.header.title': 'Столик 1 — Меню',
  'table.header.items': 'позиція(й) у кошику',

  'table.sidebar.categories': 'Категорії',
  'table.sidebar.system': 'Стан системи',
  'table.sidebar.terminal': 'Термінал',
  'table.sidebar.server': 'Сервер',
  'table.sidebar.online': 'В мережі',
  'table.sidebar.stable': 'Стабільно',

  'table.main.menu': 'Меню',
  'table.main.featured': 'Популярні страви',
  'table.main.items': 'позицій',
  'table.main.addOrder': 'Додати до замовлення',
  'table.main.dishPreview': 'Зображення страви',
  'table.main.categoryAll': 'Усі',

  'table.main.category.breakfast': 'Сніданок',
  'table.main.category.dessert': 'Десерти',
  'table.main.category.drinks': 'Напої',
  'table.main.category.lunch': 'Обід',

  'table.aside.summary': 'Зведення замовлення',
  'table.aside.empty': 'Кошик порожній',
  'table.aside.selectItems': 'Оберіть позиції з меню, щоб почати',
  'table.aside.items': 'Позиції',
  'table.aside.total': 'Разом',
  'table.aside.create': 'Створити замовлення',
  'table.aside.confirm': 'Підтвердити замовлення',
  'table.confirm.title': 'Ваше замовлення',
  'table.confirm.ok': 'ОК',
  'table.confirm.edit': 'Редагувати',
  'table.confirm.delete': 'Видалити',
  'table.aside.callWaiter': 'Викликати офіціанта',
  'table.aside.waiterCalled': 'Офіціанта вже викликано',
  'table.aside.lastOrder': 'Останнє замовлення',
  'table.aside.currentOrder': 'Поточне замовлення',
  'table.aside.orderNumber': 'Замовлення',
  'table.main.inCart': 'У кошику',

  'table.voice.title': 'Голосовий помічник',
  'table.voice.status': 'Стан',
  'table.voice.listening': '🎤 Слухаю',
  'table.voice.ready': '✓ Готово',
  'table.voice.lastCommand': 'Остання команда',
  'table.voice.awaiting': 'Очікування голосової команди',
  'table.voice.feedback': 'Зворотний зв\'язок',
  'table.voice.transcript': 'Транскрипт',
  'table.voice.none': '(немає)',
  'table.voice.examples': 'Спробуйте сказати:',
  'table.voice.example1': 'показати напої',
  'table.voice.example2': 'додати латте',
  'table.voice.example3': 'очистити кошик',
  'table.voice.example4': 'створити замовлення',
  'table.voice.button': 'Привіт Люме',
  'table.voice.unsupported': 'Розпізнавання голосу не підтримується у цьому браузері',

  // Kitchen Screen
  'kitchen.header.label': 'Кухонна станція',
  'kitchen.header.title': 'Черга замовлень',
  'kitchen.header.active': 'активно',

  'kitchen.filter.all': 'Усі замовлення',
  'kitchen.empty.ready': '🍳',
  'kitchen.empty.message': 'Немає замовлень у черзі',
  'kitchen.empty.subtext': 'Готові до обслуговування',

  'kitchen.order.label': 'Замовлення',
  'kitchen.order.items': 'позиція',
  'kitchen.order.table': 'Столик',
  'kitchen.order.total': 'Разом',
  'kitchen.order.items.label': 'Позиції:',
  'kitchen.order.markAs': 'Позначити як',
  'kitchen.timer.label': 'Таймер подачі',
  'kitchen.timer.ready': 'Готово',
  'kitchen.timer.min': 'хв',
  'kitchen.timer.cancel': 'Скинути',
  'table.timer.ready': 'Скоро подамо',

  // Admin Screen
  'admin.header.label': 'Панель адміністратора',
  'admin.header.title': 'Зведення замовлень',
  'admin.header.totalLabel': 'усього',
  'admin.loginJournal.currentUser': 'Увійшов',
  'admin.loginJournal.eyebrow': 'ЖУРНАЛ ВХОДІВ',
  'admin.loginJournal.title': 'Журнал входів',
  'admin.loginJournal.refresh': 'Оновити',
  'admin.loginJournal.clear': 'Очистити список',
  'admin.loginJournal.clearing': 'Очищення...',
  'admin.loginJournal.loadError': 'Не вдалося завантажити журнал входів.',
  'admin.loginJournal.clearError': 'Не вдалося очистити журнал входів.',
  'admin.loginJournal.empty': 'Записів входу поки немає.',
  'admin.loginJournal.time': 'Час',
  'admin.loginJournal.fullName': 'Повне ім\'я',
  'admin.loginJournal.role': 'Роль',
  'admin.loginJournal.loginType': 'Спосіб входу',
  'admin.loginJournal.accessKey': 'Ключ / ID',
  'admin.loginJournal.device': 'Пристрій / джерело',
  'admin.loginJournal.typeManual': 'Ім\'я користувача та пароль',
  'admin.loginJournal.typeInitialSetup': 'Початкове налаштування',
  'admin.loginJournal.typeQr': 'QR-код',
  'admin.loginJournal.typeLogout': 'Вихід',
  'admin.loginJournal.roleAdmin': 'Адміністратор',
  'admin.loginJournal.roleKitchen': 'Кухня',
  'admin.loginJournal.roleStaff': 'Персонал',
  'admin.loginJournal.roleGuest': 'Гість',
  'admin.access.eyebrow': 'Доступ до застосунку',
  'admin.access.title': 'Налаштування доступу до застосунку',
  'admin.access.description': 'Додайте співробітників, які користуватимуться застосунком. Кожен співробітник входить зі своїм ім\'ям користувача та паролем.',
  'admin.access.adminSection': 'Ваш доступ адміністратора',
  'admin.access.currentKey': 'Ім\'я користувача',
  'admin.access.username': 'Ім\'я користувача',
  'admin.access.newPassword': 'Новий пароль',
  'admin.access.repeatPassword': 'Повторіть пароль',
  'admin.access.newRecoveryCode': 'Новий ідентифікаційний код відновлення',
  'admin.access.repeatRecoveryCode': 'Повторіть ідентифікаційний код',
  'admin.access.usersTitle': 'Користувачі застосунку',
  'admin.access.addUser': 'Додати користувача',
  'admin.access.fullName': 'Повне ім\'я',
  'admin.access.password': 'Пароль',
  'admin.access.role': 'Роль',
  'admin.access.roleAdmin': 'Адміністратор',
  'admin.access.roleKitchen': 'Кухня',
  'admin.access.roleStaff': 'Персонал',
  'admin.access.delete': 'Видалити',
  'admin.access.save': 'Зберегти',
  'admin.access.saving': 'Збереження...',
  'admin.access.passwordMismatch': 'Паролі не збігаються',
  'admin.access.recoveryCodeMismatch': 'Ідентифікаційні коди не збігаються',
  'admin.access.duplicateKey': 'Користувач із таким ім\'ям вже існує',
  'admin.access.reservedUsername': 'Це ім\'я користувача зарезервовано системою.',
  'admin.access.saved': 'Доступ збережено',
  'admin.access.cannotDeleteLastAdmin': 'Не можна видалити останнього адміністратора',
  'admin.access.cannotDeleteCurrentUser': 'Не можна видалити поточного користувача',
  'admin.access.loading': 'Завантаження налаштувань доступу...',
  'admin.access.loadError': 'Не вдалося завантажити налаштування доступу.',
  'admin.access.saveError': 'Не вдалося зберегти налаштування доступу.',
  'admin.access.addUserError': 'Не вдалося додати користувача',
  'admin.access.requiredError': 'Заповніть повне ім\'я, ім\'я користувача, пароль і роль.',
  'admin.access.adminRequiredError': 'Введіть ім\'я користувача адміністратора.',
  'admin.access.startWorkday': 'Закрити та розпочати робочий день',
  'admin.access.empty': 'Користувачів доступу ще не додано.',
  'admin.appSettings.eyebrow': 'Параметри застосунку',
  'admin.appSettings.title': 'Налаштування застосунку',
  'admin.appSettings.description': 'Вкажіть дані закладу та використовуйте локальні посилання для підключення кухні й персоналу до цього комп\'ютера.',
  'admin.appSettings.venueName': 'Назва закладу',
  'admin.appSettings.venueDescription': 'Опис',
  'admin.appSettings.venueDescriptionHint': 'Короткий опис для мобільної версії',
  'admin.appSettings.venueOpeningHours': 'Години роботи за днями тижня',
  'admin.appSettings.venuePhone': 'Телефон закладу',
  'admin.appSettings.venueAddress': 'Адреса закладу',
  'admin.appSettings.venuePostalCode': 'Поштовий індекс',
  'admin.appSettings.venueLocation': 'Геолокація закладу',
  'admin.appSettings.venueLocationHint': 'Підтвердіть точку закладу для відображення на порталі.',
  'admin.appSettings.venueLocationConfirm': 'Підтвердити геолокацію',
  'admin.appSettings.venueLocationSaving': 'Визначаємо...',
  'admin.appSettings.venueLocationSaved': 'Геолокацію закладу збережено для порталу.',
  'admin.appSettings.venueLocationDenied': 'Доступ до геолокації заборонено. Надайте доступ і повторіть спробу.',
  'admin.appSettings.venueLocationError': 'Не вдалося зберегти геолокацію закладу.',
  'admin.appSettings.venueLocationPrivacyHint': 'Якщо не працює: Системні налаштування → Конфіденційність і безпека → Служби геолокації → надайте доступ для застосунку.',
  'admin.appSettings.monday': 'Понеділок',
  'admin.appSettings.tuesday': 'Вівторок',
  'admin.appSettings.wednesday': 'Середа',
  'admin.appSettings.thursday': 'Четвер',
  'admin.appSettings.friday': 'П\'ятниця',
  'admin.appSettings.saturday': 'Субота',
  'admin.appSettings.sunday': 'Неділя',
  'admin.appSettings.dayWorking': 'Працюємо',
  'admin.appSettings.dayOff': 'Вихідний',
  'admin.appSettings.dayOffNote': 'Цього дня зачинено',
  'admin.appSettings.kitchenUrl': 'URL для входу комп\'ютера кухні',
  'admin.appSettings.staffUrl': 'URL для входу комп\'ютера персоналу',
  'admin.appSettings.copy': 'Копіювати',
  'admin.appSettings.linkCopied': 'Посилання скопійовано',
  'admin.appSettings.save': 'Зберегти налаштування',
  'admin.appSettings.saving': 'Збереження...',
  'admin.appSettings.saved': 'Налаштування збережено',
  'admin.appSettings.requiredVenueName': 'Введіть назву закладу',
  'admin.appSettings.invalidVenuePhone': 'Введіть коректний телефон закладу з кодом країни',
  'admin.appSettings.invalidVenueEmail': 'Введіть коректний email закладу',
  'admin.appSettings.networkHint': 'Усі пристрої мають бути підключені до однієї мережі Wi‑Fi. Інтернет не потрібен, але головний комп\'ютер має залишатися ввімкненим.',
  'admin.appSettings.localOnly': 'Працює без інтернету у локальній мережі',
  'admin.appSettings.loading': 'Завантаження налаштувань застосунку...',
  'admin.appSettings.loadError': 'Не вдалося завантажити налаштування застосунку.',
  'admin.appSettings.saveError': 'Не вдалося зберегти налаштування застосунку.',
  'admin.appSettings.completeProfileFirst': 'Спершу заповніть профіль закладу (назва, телефон, e-mail) і збережіть його — після цього можна приховувати ціни на вітрині.',
  'admin.backups.eyebrow': 'Резервні копії бази',
  'admin.backups.title': 'Резервне копіювання та відновлення',
  'admin.backups.body': 'Створюйте локальні резервні копії бази та за необхідності відновлюйте застосунок із наявного знімку. Для відновлення потрібне підтвердження паролем адміністратора.',
  'admin.backups.loading': 'Завантаження резервних копій...',
  'admin.backups.create': 'Створити копію зараз',
  'admin.backups.creating': 'Створення копії...',
  'admin.backups.refresh': 'Оновити',
  'admin.backups.latest': 'Остання створена копія',
  'admin.backups.emptyWindow': 'Копії ще немає',
  'admin.backups.restore': 'Відновити',
  'admin.backups.restoreTitle': 'Підтвердіть відновлення',
  'admin.backups.restoreBody': 'Для перевстановлення застосунку з вибраної резервної копії введіть пароль поточного адміністратора. Поточну базу буде замінено, а перед цим система автоматично створить захисну копію.',
  'admin.backups.passwordPlaceholder': 'Введіть пароль адміністратора',
  'admin.backups.confirmRestore': 'Підтвердити відновлення',
  'admin.backups.cancelRestore': 'Скасувати',
  'admin.backups.restoring': 'Відновлення...',
  'admin.backups.windowHour': 'За 1 годину',
  'admin.backups.windowDay': 'За 1 день',
  'admin.backups.windowWeek': 'За 1 тиждень',
  'admin.backups.windowMonth': 'За 1 місяць',
  'admin.backups.loadError': 'Не вдалося завантажити резервні копії.',
  'admin.backups.createError': 'Не вдалося створити резервну копію.',
  'admin.backups.restoreError': 'Не вдалося відновити базу з резервної копії.',
  'admin.backups.createSuccess': 'Резервну копію створено.',
  'admin.backups.restoreSuccess': 'Базу відновлено з резервної копії.',
  'admin.backups.autoHint': 'Автоматичне резервне копіювання типово вимкнено. Коли увімкнено, застосунок автоматично підтримує 4 слоти резервних копій: 1 година, 1 день, 1 тиждень і 1 місяць.',
  'admin.backups.autoEnabled': 'Авторезервування: увімк.',
  'admin.backups.autoDisabled': 'Авторезервування: вимк.',
  'admin.backups.autoSaving': 'Збереження...',
  'admin.backups.autoEnableSuccess': 'Автоматичне резервне копіювання увімкнено.',
  'admin.backups.autoDisableSuccess': 'Автоматичне резервне копіювання вимкнено.',
  'admin.backups.autoToggleError': 'Не вдалося змінити режим автоматичного резервного копіювання.',

  'admin.empty.message': 'Замовлень ще немає. Очікування першого замовлення зі столика.',

  'admin.stats.title': 'Статистика',
  'admin.stats.totalOrders': 'Усього замовлень',
  'admin.stats.totalRevenue': 'Оплачений дохід',
  'admin.stats.pendingPayments': 'Очікують оплати',

  'admin.breakdown.title': 'Розподіл за статусами',

  'admin.orders.title': 'Усі замовлення',
  'admin.orders.empty': 'Замовлень ще немає.',
  'admin.orders.tableLabel': 'Столик',
  'admin.orders.markServed': 'Позначити як подано',
  'admin.orders.markPaid': 'Позначити як оплачено',
  'admin.orders.markCancelled': 'Позначити як скасовано',
  'admin.orders.waiterCall': 'Виклик офіціанта',
  'admin.orders.itemSingular': 'позиція',
  'admin.orders.itemsPlural': 'позицій',
  'admin.orders.timeLabel': 'Час',

  // Admin Menu Management
  'admin.menu.title': 'Управління меню',
  'admin.menu.addItem': 'Додати страву',
  'admin.menu.editItem': 'Редагувати страву',
  'admin.menu.name': 'Назва',
  'admin.menu.category': 'Категорія',
  'admin.menu.selectCategory': 'Оберіть категорію',
  'admin.menu.price': 'Ціна',
  'admin.menu.image': 'URL зображення',
  'admin.menu.description': 'Опис',
  'admin.menu.available': 'Показувати страву в меню та вітрині',
  'admin.menu.active': 'Активно',
  'admin.menu.inactive': 'Приховано',
  'admin.menu.save': 'Зберегти',
  'admin.menu.create': 'Створити',
  'admin.menu.cancel': 'Скасувати',
  'admin.menu.empty': 'Меню поки порожнє.',
  'admin.menu.edit': 'Редагувати',
  'admin.menu.delete': 'Видалити',
  'admin.menu.continue': 'Продовжити',

  'admin.tables.title': 'Управління столиками',
  'admin.tables.add': 'Додати столик',
  'admin.tables.panelTitle': 'Додати столик',
  'admin.tables.completedTitle': 'Налаштування завершено',
  'admin.tables.completedBadge': 'Готово',
  'admin.tables.completedDescription': 'Скопіюйте посилання столика та відкрийте його на потрібному моніторі, а потім встановіть сторінку як застосунок.\n\nВи також можете завантажити QR-коди та розмістити їх на столах — відвідувачі зможуть відкрити електронне меню та зробити замовлення зі свого телефону.\n\nПеред запуском переконайтеся, що всі пристрої підключено до однієї локальної мережі кафе.',
  'admin.tables.close': 'Закрити',
  'admin.tables.continue': 'Продовжити',
  'admin.tables.edit': 'Редагувати столик',
  'admin.tables.name': 'Назва',
  'admin.tables.accessCode': 'Код доступу',
  'admin.tables.pin': 'PIN',
  'admin.tables.status': 'Статус',
  'admin.tables.capacity': 'Місткість',
  'admin.tables.note': 'Нотатка',
  'admin.tables.active': 'Активний',
  'admin.tables.inactive': 'Неактивний',
  'admin.tables.id': 'ID',
  'admin.tables.save': 'Зберегти',
  'admin.tables.create': 'Створити',
  'admin.tables.cancel': 'Скасувати',
  'admin.tables.delete': 'Видалити',
  'admin.tables.activate': 'Активувати',
  'admin.tables.deactivate': 'Деактивувати',
  'admin.tables.empty': 'Столиків ще не налаштовано.',
  'admin.tables.deleteConfirm': 'Ви впевнені, що хочете видалити цей столик?',
  'admin.tables.deleteWithOrdersConfirm': 'Закрити пов\'язані замовлення та видалити столик?',
  'admin.tables.lanEyebrow': 'Локальна мережа закладу',
  'admin.tables.lanBody': 'Цю адресу використовують гостьові телефони у Wi‑Fi закладу напряму, навіть без доступу до інтернету.',
  'admin.tables.lanUnavailable': 'Локальна LAN-адреса ще не визначена. Локальний бекенд продовжує працювати, але для QR-посилань потрібна доступна адреса у мережі Wi‑Fi.',
  'admin.tables.guestLanTitle': 'LAN-гостьове посилання',
  'admin.tables.copyLanLink': 'Копіювати посилання',
  'admin.tables.openLanLink': 'Відкрити столик',
  'admin.tables.copied': 'Скопійовано',
  'admin.tables.qrPreview': 'QR столика',
  'admin.tables.qrCaption': 'Покажіть QR на екрані адміністратора або скористайтеся посиланням нижче на телефоні, підключеному до тієї самої мережі Wi‑Fi закладу.',
  'admin.tables.downloadQr': 'Завантажити QR',
  'admin.tables.printCard': 'Друкувати картку',
  'admin.tables.printInstruction': 'Скануйте QR-код, щоб відкрити меню',
  'admin.tables.printWifiHint': 'Підключіться до Wi-Fi закладу та скануйте QR-код, щоб відкрити меню',
  'admin.tables.printPinLabel': 'PIN для входу',

  'admin.storefront.eyebrow': 'Вітрина закладу',
  'admin.storefront.title': 'Фото входу, інтер\'єр і пасивний екран вітрини',
  'admin.storefront.body': 'Налаштуйте вітрину перед режимом столиків: фото входу, інтер\'єрні знімки та пасивна ротація активних страв.',
  'admin.storefront.open': 'Відкрити вітрину',
  'admin.storefront.monitorUrl': 'URL для монітора вітрини',
  'admin.storefront.showPrices': 'Показувати ціни на стравах',
  'admin.storefront.showPricesHint': 'Якщо увімкнено, ціна відображатиметься лише на картках страв вітрини.',
  'admin.storefront.pricesOn': 'Ціни увімкнено',
  'admin.storefront.pricesOff': 'Ціни приховано',
  'admin.storefront.photoFile': 'Фото закладу',
  'admin.storefront.photoType': 'Тип фото',
  'admin.storefront.photoSort': 'Порядок',
  'admin.storefront.upload': 'Завантажити фото',
  'admin.storefront.note': 'Використовуйте 1 фото входу та будь-яку кількість інтер\'єрних. Вертикальні знімки автоматично адаптуються для горизонтальних дисплеїв.',
  'admin.storefront.portalEntranceNote': 'На портал надходить лише фото типу «Вхід». Інтер\'єр, вітрина та зображення страв залишаються локально.',
  'admin.storefront.portalEntranceBadge': 'Фото для порталу',
  'admin.storefront.typeEntrance': 'Вхід',
  'admin.storefront.typeInterior': 'Інтер\'єр',
  'admin.storefront.entranceExists': 'Фото входу вже додано — фото інтер\'єру можна завантажити скільки завгодно.',
  'admin.storefront.orderLabel': 'Порядок:',
  'admin.storefront.remove': 'Видалити',
  'admin.storefront.empty': 'Фотографій вітрини ще не завантажено.',
  'admin.storefront.continue': 'Продовжити',
  'admin.storefront.photoRequired': 'Спочатку оберіть зображення для вітрини.',
  'admin.storefront.uploadError': 'Не вдалося завантажити фотографію вітрини.',

  // Order Statuses
  'status.new': 'Нове замовлення',
  'status.inProgress': 'У роботі',
  'status.ready': 'Готово до подачі',
  'status.served': 'Подано',
  'status.paid': 'Оплачено',
  'status.cancelled': 'Скасовано',

  // Payment Statuses
  'payment.pending': 'Очікує оплати',
  'payment.paid': 'Оплачено',
  'payment.failed': 'Помилка оплати',
  'payment.cancelled': 'Оплата не потрібна',

  'table.header.menuSuffix': 'Меню',
  'table.header.accessCode': 'Доступ',
  'table.header.inactive': 'Цей екран столика неактивний.',
  'table.header.unassigned': 'Цей екран столика ще не налаштовано.',
  'table.access.label': 'Доступ до столика',
  'table.access.openingTable': 'Ви відкриваєте стіл замовлень',
  'table.access.titleFallback': 'Екран столика',
  'table.access.loading': 'Завантаження доступу до столика...',
  'table.access.slug': 'URL столика',
  'table.access.prompt': 'Введіть PIN-код, щоб відкрити екран замовлень цього столика.',
  'table.access.pinLabel': 'PIN / Пароль',
  'table.access.unlock': 'Відкрити столик',
  'table.access.unlocking': 'Перевірка...',
  'table.access.pinInvalid': 'Невірний PIN',
  'table.access.missingSlug': 'Відкрийте URL конкретного столика, наприклад /table/t1, щоб скористатися цим екраном.',
  'table.access.keypadHint': 'PIN-панель працює як із сенсорним екраном, так і з мишею.',
  'table.access.clear': 'Очистити',
  'table.access.deviceTitle': 'Сенсорний доступ',
  'table.access.deviceBody': 'Розроблено для моніторів і планшетів на столиках: великі елементи керування та легкий кіоск-стиль розблокування.',
  'table.access.rememberTitle': 'Запам\'ятовується на пристрої',
  'table.access.rememberBody': 'Після успішного входу пристрій залишається авторизованим, доки PIN столика не зміниться або доступ не буде скинуто.',
  'table.intro.eyebrow': 'Гостьовий екран столика',
  'table.intro.body': 'Перед інтерактивним меню гість бачить спокійну вступну сцену цього столика з фотографіями закладу та активними стравами дня.',
  'table.intro.openMenu': 'Відкрити меню',
  'table.intro.startOrder': 'Почати замовлення',
  'table.intro.entranceKicker': 'Вхід до закладу',
  'table.intro.interiorKicker': 'Інтер\'єр',
  'table.intro.entranceTitle': 'Ласкаво просимо до закладу',
  'table.intro.interiorTitle': 'Усередині',
  'table.intro.entranceBody': 'Перший екран знайомить гостя з місцем і плавно веде до перегляду меню цього столика.',
  'table.intro.interiorBody': 'Інтер\'єрні знімки підтримують сцену очікування перед переходом до інтерактивного замовлення.',
  'table.intro.entranceBadge': 'Вхід',
  'table.intro.interiorBadge': 'Інтер\'єр',
  'table.intro.photoPlaceholder': 'На цьому екрані відображатимуться фотографії закладу та активні позиції меню.',
  'table.intro.dishKicker': 'Активна страва',
  'table.intro.dishBadge': 'Меню сьогодні',
  'table.intro.dishBody': 'У вступі столика беруть участь лише активні страви, і ті самі страви доступні після відкриття меню.',
  'table.intro.welcome': 'Ласкаво просимо',
  'table.intro.todayMenu': 'Меню сьогодні',
  'table.intro.rotationNote': 'слайди змінюються автоматично',
  'table.intro.emptyKicker': 'Старт столика',
  'table.intro.emptyTitle': 'Екран столика готовий до меню',
  'table.intro.emptyBody': 'Після додавання фотографій закладу та активних страв вони автоматично братимуть участь у вступній ротації цього столика.',
  'table.intro.emptyBadge': 'Очікування',
  'table.intro.highlightOne': 'Спочатку столик представляє заклад і лише потім відкриває інтерфейс замовлення.',
  'table.intro.highlightTwo': 'Вертикальні знімки зберігають пропорції та заповнюють горизонтальну сцену м\'яким розмитим фоном.',
  'table.intro.highlightThree': 'У вступі та меню беруть участь лише активні страви.',
  'table.intro.highlightFour': 'Посилання столика залишається незмінним на всьому шляху гостя: QR веде одразу до потрібного столика.',
  'table.waiter.label': 'Робоче місце офіціанта',
  'table.waiter.title': 'Столи в роботі',
  'table.waiter.activeTable': 'Обраний столик',
  'table.waiter.loadingTables': 'Завантаження столиків...',
  'table.waiter.markServed': 'Позначити замовлення як подано',
  'table.waiter.markPaid': 'Позначити замовлення як оплачено',
  'table.waiter.markCancelled': 'Скасувати замовлення',
  'table.waiter.resolveCall': 'Зняти виклик офіціанта',
  'table.waiter.noTables': 'Столики ще не створено. Додайте їх в адмінці.',
  'table.waiter.noActiveTables': 'Наразі немає активних столиків. Активуйте принаймні один столик в адмінці.',
  'storefront.display.configure': 'Налаштувати показ',
  'storefront.display.addEffects': 'Додати ефекти',
  'storefront.display.dishesPerScreen': 'Страв на одному екрані',
  'storefront.display.save': 'Зберегти',
  'storefront.display.effectNone': 'Без ефекту',
  'storefront.display.effectFade': 'Плавна поява',
  'storefront.display.effectSlide': 'Зсув',
  'storefront.display.effectZoom': 'М’яке збільшення',
  'storefront.display.effectRandom': 'Випадкові ефекти',
  'storefront.display.settingsSaved': 'Налаштування збережено',
  'storefront.display.saveError': 'Не вдалося зберегти налаштування',
  'storefront.display.minimumTwo': 'Значення має бути не менше 2',
  'storefront.display.close': 'Закрити',
  'storefront.display.loading': 'Завантаження вітрини...',
  'storefront.display.loadErrorTitle': 'Помилка завантаження',
  'storefront.display.loadErrorBody': 'Не вдалося завантажити дані. Перевірте налаштування застосунку.',
  'storefront.display.emptyTitle': 'Вітрина порожня',
  'storefront.display.emptyBody': 'Додайте фотографії закладу або страви в панелі адміністратора.',
  'storefront.display.retry': 'Спробувати знову',
  'storefront.eyebrow': 'Локальна вітрина',
  'storefront.title': 'Пасивний екран закладу до режиму столиків',
  'storefront.body': 'Цей екран циклічно показує вхід, інтер\'єр та активні страви на горизонтальному дисплеї. Він працює пасивно — без елементів замовлення.',
  'storefront.backToEditor': 'Назад до редактора',
  'storefront.info.photos': 'Ротація починається з входу та інтер\'єру закладу.',
  'storefront.info.menu': 'У ротацію вітрини включаються лише активні страви.',
  'storefront.info.passive': 'Цей режим призначений лише для відображення та не відкриває замовлення для гостей.',
  'storefront.info.local': 'Контент зберігається локально та готовий до автономної роботи.',
  'storefront.photo.entranceKicker': 'Вхід',
  'storefront.photo.interiorKicker': 'Інтер\'єр',
  'storefront.photo.entranceTitle': 'Вхід до закладу',
  'storefront.photo.interiorTitle': 'Інтер\'єр закладу',
  'storefront.photo.entranceBody': 'Перший екран знайомить аудиторію зі входом до закладу та дає чітке відчуття прибуття.',
  'storefront.photo.interiorBody': 'Наступний кадр поглиблює атмосферу одним з інтер\'єрних видів закладу.',
  'storefront.photo.entranceBadge': 'Фото входу',
  'storefront.photo.interiorBadge': 'Фото інтер\'єру',
  'storefront.photo.placeholder': 'Завантажте вертикальні фотографії закладу, щоб запустити ротацію вітрини.',
  'storefront.dishKicker': 'Активна страва',
  'storefront.dishBadge': 'Меню сьогодні',
  'storefront.dishEyebrow': 'Позиція в ротації',
  'storefront.dishBody': 'Активна страва бере участь у ротації вітрини та залишається доступною в інтерактивному меню столиків.',
  'storefront.dishPlaceholder': 'Ця страва ще не має фотографії. Вітрина може відображати картку страви без спотворення дисплея.',
  'storefront.emptyKicker': 'Налаштування вітрини',
  'storefront.emptyTitle': 'Додайте фото входу та активні страви',
  'storefront.emptyBody': 'Після першого налаштування вітрина почне циклічно показувати фотографії закладу та активні позиції меню.',
  'storefront.emptyBadge': 'Порожньо',

  // Portal
  'portal.kicker': 'Просторовий портал закладів',
  'portal.headline': 'Увійдіть у живу карту майбутніх закладів',
  'portal.guidance.first': 'Перед вами реальна система закладу: завантажте пакет, встановіть оболонку, відкрийте адмін-портал або одразу перейдіть у вибраний заклад.',
  'portal.guidance.returning': 'Земля пам\'ятає ваш останній заклад. Зробіть паузу, дайте камері повернутися, а потім продовжте роботу або перейдіть до іншого міста.',
  'portal.memory.label': 'Пам\'ять місця',
  'portal.memory.first': 'Оберіть один заклад один раз, і вхідний екран запам\'ятає, з якого місця має починатися наступний сеанс.',
  'portal.memory.returning': 'Ваш останній заклад збережено на цьому пристрої, тому портал може повернути вас назад без втрати глобального огляду.',
  'portal.loading.label': 'Калібрування Землі',
  'portal.loading.body': 'Підготовка вхідного порталу, пам\'яті закладу та шарів просторової навігації.',
  'portal.scale.global': 'Глобальна орбіта',
  'portal.scale.country': 'Країна',
  'portal.scale.city': 'Місто',
  'portal.scale.district': 'Район',
  'portal.scale.venue': 'Заклад',
  'portal.interaction': 'Перетягніть для обертання, зведіть пальці або прокрутіть колесо для масштабування, натисніть сигнали для фокусування на закладах',
  'portal.timeline.download': 'Завантажити',
  'portal.timeline.downloadValue': 'Отримати пакет запуску',
  'portal.timeline.install': 'Встановити',
  'portal.timeline.installValue': 'Підготувати кіоск-оболонку',
  'portal.timeline.enter': 'Увійти',
  'portal.timeline.enterValue': 'Обрати заклад',
  'portal.editorial.title': 'Модулі цифрової газети',
  'portal.selectedVenue': 'Обраний заклад',
  'portal.district': 'Район',
  'portal.street': 'Вулиця',
  'portal.status.live': 'Live',
  'portal.status.preview': 'Preview',
  'portal.status.offline': 'Offline',
  'portal.actions.download': 'Завантажити для Windows',
  'portal.actions.install': 'Показати встановлення',
  'portal.actions.admin': 'Відкрити адмін-портал',
  'portal.actions.enter': 'Увійти в заклад',
  'portal.actions.unavailable': 'Заклад недоступний',
  'portal.install.label': 'Шлях встановлення',
  'portal.install.body': 'Реальний запуск закладу починається з пристрою, локальної оболонки та маршруту порталу, якому персонал може довіряти одразу.',
  'portal.controls.enableLocation': "Увімкнути геолокацію",
  'portal.controls.locationGuide': "Як увімкнути",
  'portal.share.title': "HELFER — карта кафе та ресторанів",
  'portal.install.downloadStarted': "Завантаження почалося…",
  'portal.install.downloadHint': "Завантаження почалося — файл з’явиться в теці «Завантаження». Інсталятор великий (~150 МБ), це займе трохи часу.",
  'portal.install.step1Title': '1. Завантажити',
  'portal.install.step1Body': 'Надішліть пакет запуску власнику закладу або партнеру з встановлення.',
  'portal.install.step2Title': '2. Встановити',
  'portal.install.step2Body': 'Відкрийте shell або browser wrapper на цільовому екрані та закріпіть staging URL.',
  'portal.install.step3Title': '3. Увійти',
  'portal.install.step3Body': 'Використовуйте запам\'ятований маршрут закладу та PIN-вхід для переходу до реального table-flow.',
  'portal.cards.local.kicker': 'Local First',
  'portal.cards.local.title': 'Вхід у заклад перед панеллю керування',
  'portal.cards.local.body': 'Перший екран має орієнтувати гостей, операторів та інсталяторів навколо реального місця, а не абстрактного програмного лобі.',
  'portal.cards.future.kicker': 'Future Module',
  'portal.cards.future.title': 'Встановлення, адмін і live-вхід залишаються на відстані одного жесту',
  'portal.cards.future.body': 'Практичні дії завжди видимі, тому занурення підтримує роботу з системою, а не замінює її.',
  'portal.cards.story.kicker': 'Editorial',
  'portal.cards.story.title': 'Перша сторінка цифрової газети для мережі закладів',
  'portal.cards.story.body': 'Короткі концептуальні блоки пояснюють розвиток системи, не витісняючи просторову карту з центру уваги.',
  'portal.cards.assistant.kicker': 'Assistant',
  'portal.cards.assistant.title': 'Підказки без шуму',
  'portal.cards.assistant.body': 'Анімація і текст залишаються спокійними, обдуманими та переконливими, щоб портал виглядав преміально на телефонах, планшетах і настінних дисплеях.',
  'portal.rotating.seeker.title': 'Знайдіть потрібне місце швидше',
  'portal.rotating.seeker.body': 'Відкривайте кафе та ресторани через живий просторовий портал.',
  'portal.rotating.owner.title': 'Маєте власний заклад?',
  'portal.rotating.owner.body': 'Встановіть локальний інструмент просування та з\'явіться всередині живого порталу.',
  'portal.business.hero.eyebrow': 'ЖИВИЙ ПОРТАЛ',
  'portal.business.hero.title': 'Живий портал шукає нові кафе та ресторани',
  'portal.business.hero.body': 'Приєднуйтесь безкоштовно, знайдіть свій заклад у системі та запустіть робоче ПЗ для локального режиму, реклами та присутності всередині порталу.',
  'portal.business.hero.primary': 'Обрати зі списку бізнесів — кафе та ресторани',
  'portal.business.hero.secondary': 'Дізнатися про режими підключення',
  'portal.business.hero.later': 'Пізніше',
  'portal.business.modes.free.label': 'Вільний вхід',
  'portal.business.modes.free.title': 'Приєднатися безкоштовно',
  'portal.business.modes.free.body': 'Локальна автономна робота безкоштовна. Цей режим підтримується рекламою.',
  'portal.business.modes.silent.label': 'Тихий локальний контур',
  'portal.business.modes.silent.title': 'Локальна робота без реклами',
  'portal.business.modes.silent.body': 'Локальна робота без рекламного шару доступна за підпискою.',
  'portal.business.modes.growth.label': 'Режим росту',
  'portal.business.modes.growth.title': 'Просування всередині порталу',
  'portal.business.modes.growth.body': 'Локальна робота без реклами плюс посилена присутність усередині живого порталу. Підписка.',
  'portal.business.entry.eyebrow': 'BUSINESS ENTRY',
  'portal.business.entry.title': 'Оберіть тип закладу',
  'portal.business.entry.body': 'Спочатку оберіть категорію бізнесу. Шлях встановлення має залишатися доступним навіть без геолокації.',
  'portal.business.entry.placeholder': 'Кафе або ресторани',
  'portal.business.entry.option.cafe': 'Кафе',
  'portal.business.entry.option.restaurant': 'Ресторани',
  'portal.business.entry.install': 'Встановити застосунок на цей пристрій',
  'portal.business.entry.locationFallback': 'Геолокація недоступна, але вхід для бізнесу залишається відкритим.',
  'portal.business.platform.eyebrow': 'BUSINESS ENTRY',
  'portal.business.platform.title': 'Оберіть платформу підключення',
  'portal.business.platform.windows.title': 'Windows',
  'portal.business.platform.windows.body': 'Завантажити локальний застосунок для Windows',
  'portal.business.platform.windows.button': 'Завантажити .exe',
  'portal.business.platform.mac.title': 'Mac',
  'portal.business.platform.mac.body': 'Запустити через браузер як вікно застосунку',
  'portal.business.platform.mac.button': 'Інструкція для Mac',
  'portal.business.platform.portal.title': 'Портал',
  'portal.business.platform.portal.body': 'Працювати з прив\'язкою до живого порталу',
  'portal.business.platform.portal.button': 'Відкрити портальний режим',
  'portal.business.mac.eyebrow': 'ВСТАНОВЛЕННЯ ЧЕРЕЗ БРАУЗЕР',
  'portal.business.mac.title': 'Встановлення на Mac',
  'portal.business.mac.body': 'На Mac застосунок наразі встановлюється через браузер як окреме вікно застосунку.',
  'portal.business.mac.safari.title': 'Safari',
  'portal.business.mac.safari.body': 'Відкрийте портал у Safari та оберіть «Додати до Dock».',
  'portal.business.mac.chrome.title': 'Chrome',
  'portal.business.mac.chrome.body': 'Відкрийте портал у Chrome та оберіть «Встановити застосунок».',
  'portal.business.mac.footer': 'Цей режим підходить для локальної роботи, тестування та запуску на Mac без окремого .dmg.',
  'portal.business.portal.eyebrow': 'ПОРТАЛЬНИЙ РЕЖИМ',
  'portal.business.portal.title': 'Робота з прив\'язкою до живого порталу',
  'portal.business.portal.body': 'Цей режим зберігає зв\'язок із живим порталом і дозволяє закладу брати участь у відкритті та просуванні, не замінюючи локальну роботу.',
  'portal.business.openPortal': 'Відкрити портал',
  'portal.business.close': 'Закрити',
  'portal.banner.eyebrow': 'ПОРТАЛ',
  'portal.banner.message1': 'Відкрийте портал і оберіть події на сьогодні',
  'portal.banner.message2': 'Безкоштовно встановіть інструмент свого бізнесу, і вас побачать на сторінці подій',
  'portal.banner.message3': 'Якщо ваш бізнес онлайн, встановіть HELFER online і користуйтеся найкращими інструментами',
  'portal.brand.subtitle': 'Локальний портал',
  'portal.support.label': 'Підтримка',
  'admin.support.button': 'Підтримка',
  'portal.voice.label': 'Голосовий помічник',
  'portal.voice.listening': 'Слухаю...',
  'portal.voice.speaking': 'Говоріть...',
  'portal.controls.eyebrow': 'BUSINESS ENTRY',
  'portal.controls.placeholder': 'Пошук кафе та ресторанів',
  'portal.controls.option.venues': 'Кафе та ресторани',
  'portal.controls.option.online': 'HELFER для онлайн-спеціалістів',
  'portal.controls.find': 'Відкрити карту закладів',
  'portal.controls.install': 'Встановити застосунок кафе',
  'portal.controls.searchSubmit': 'Знайти',
  'portal.controls.searchEmpty': 'Закладів за цим запитом не знайдено.',
  'portal.mobile.nav.label': 'Навігація порталу',
  'portal.mobile.nav.map': 'Карта',
  'portal.mobile.nav.search': 'Пошук',
  'portal.mobile.nav.support': 'Підтримка',
  'portal.mobile.nav.install': 'Застосунок',
  'portal.controls.back': 'Назад',
  'portal.controls.locationDenied': 'Геолокація недоступна. Ви все одно можете встановити застосунок.',
  'portal.controls.locationManual': 'Геолокація недоступна. Введіть місто або назву закладу в пошуку — карта відкриється по ньому.',
  'portal.controls.locationSecureContext': 'Для запиту геолокації відкрийте портал через HTTPS або localhost.',
  'support.eyebrow': 'Підтримка',
  'support.title': 'Зв\'язатися з підтримкою',
  'support.body': 'Залиште контактні дані та коротко опишіть проблему. Ми надішлемо запит до підтримки.',
  'support.fullName': 'Повне ім\'я',
  'support.fullNamePlaceholder': 'Введіть повне ім\'я',
  'support.contact': 'Телефон / месенджер',
  'support.contactPlaceholder': 'Наприклад, +353..., Telegram @...',
  'support.message': 'Текст запиту',
  'support.messagePlaceholder': 'Опишіть проблему або запитання',
  'support.send': 'Надіслати',
  'support.sending': 'Надсилання...',
  'support.cancel': 'Закрити',
  'support.success': 'Повідомлення надіслано до підтримки',
  'support.validation': 'Заповніть усі поля',
  'support.error': 'Не вдалося надіслати повідомлення',
  'portal.events.sheet.eyebrow': 'КАРТА ЗАКЛАДІВ',
  'portal.events.sheet.title': 'Відкрийте карту кафе та ресторанів',
  'portal.events.sheet.body': 'Можна продовжити в браузері або встановити застосунок, щоб швидше знаходити заклади поруч і повертатися до карти без зайвих кроків.',
  'portal.events.sheet.mapTitle': 'Жива карта закладів',
  'portal.events.sheet.mapBody': 'Дивіться кафе та ресторани поруч, меню, відгуки, маршрут і поточну завантаженість в одному місці.',
  'portal.events.sheet.ios': 'iPhone / App Store',
  'portal.events.sheet.android': 'Android / Google Play',
  'portal.install.comingSoon': 'Незабаром',
  'portal.events.sheet.browser': 'Відкрити в браузері',
  'portal.install.sheet.eyebrow': 'ЛОКАЛЬНЕ ВСТАНОВЛЕННЯ',
  'portal.install.sheet.title': 'HELFER для кафе та ресторанів',
  'portal.install.sheet.body': 'Встановіть локальний застосунок на комп\'ютер адміністратора, щоб приймати замовлення, керувати меню, бачити столики та показувати заклад на живій карті порталу.',
  'portal.install.sheet.value1': 'Замовлення зі столиків одразу потрапляють адміністратору й на кухню',
  'portal.install.sheet.value2': 'Меню, ціни та фото оновлюються на порталі з локального застосунку',
  'portal.install.sheet.value3': 'Завантаженість залу рахується за статусами столиків у реальному часі',
  'portal.install.sheet.value4': 'Базовий запуск без складного налаштування і залежності від хмари',
  'portal.install.sheet.note': 'Основна робота залишається на пристрої закладу.',
  'portal.install.sheet.trust': 'Базові функції безкоштовні. Вітрина, статистика й бекапи підключаються окремо, коли вони справді потрібні.',
  'portal.install.windows.title': 'Windows',
  'portal.install.windows.body': 'Завантажити локальний застосунок для Windows',
  'portal.install.windows.button': 'Завантажити для Windows',
  'portal.install.mac.title': 'Mac',
  'portal.install.mac.body': 'Завантажити локальний застосунок для macOS',
  'portal.install.mac.button': 'Завантажити для Mac',
  'portal.install.portal.title': 'Портал',
  'portal.install.portal.body': 'Працювати з прив\'язкою до живого порталу',
  'portal.install.portal.button': 'Відкрити портальний режим',
  'portal.install.mac.guide.eyebrow': 'ВСТАНОВЛЕННЯ ЧЕРЕЗ БРАУЗЕР',
  'portal.install.mac.guide.title': 'Встановлення на Mac',
  'portal.install.mac.guide.body': 'На Mac застосунок наразі встановлюється через браузер як окреме вікно застосунку.',
  'portal.install.mac.guide.safari.title': 'Safari',
  'portal.install.mac.guide.safari.body': 'Відкрийте портал у Safari та оберіть «Додати до Dock».',
  'portal.install.mac.guide.chrome.title': 'Chrome',
  'portal.install.mac.guide.chrome.body': 'Відкрийте портал у Chrome та оберіть «Встановити застосунок».',
  'portal.install.mac.guide.footer': 'Цей режим підходить для локальної роботи, тестування та запуску на Mac без окремого .dmg.',
  'portal.install.portal.guide.eyebrow': 'ПОРТАЛЬНИЙ РЕЖИМ',
  'portal.install.portal.guide.title': 'Робота з прив\'язкою до живого порталу',
  'portal.install.portal.guide.body': 'Цей режим працює з прив\'язкою до живого порталу і дає закладу участь у відкритті та просуванні.',
  'portal.install.online.eyebrow': 'HELFER ONLINE',
  'portal.install.online.title': 'Пропонуйте свої знання та послуги в HELFER',
  'portal.install.online.body': 'Зрозумілий вхід для спеціалістів: створіть профіль, покажіть курси й публікації, будуйте довіру через відгуки та допомагайте людям знаходити вас у стрічці.',
  'portal.install.online.bridgeKicker': 'Для тренерів, консультантів, викладачів та експертів',
  'portal.install.online.bridgeText': 'За кілька секунд людина має зрозуміти: тут можна ділитися знаннями, будувати довіру й бути знайденим через стрічку.',
  'portal.install.online.features.title': 'Що всередині',
  'portal.install.online.feature1': 'Профіль спеціаліста',
  'portal.install.online.feature2': 'Курси, послуги та корисні публікації',
  'portal.install.online.feature3': 'Відгуки й довіра на одній сторінці',
  'portal.install.online.feature4': 'Пошук через стрічку та фільтри',
  'portal.install.online.createProfile': 'Створити профіль спеціаліста',
  'portal.install.online.createProfileBody': 'Зареєструйтеся та оформіть сторінку з послугами, курсами й відгуками.',
  'portal.install.online.viewFeed': 'Переглянути стрічку',
  'portal.install.online.viewFeedBody': 'Подивіться, як виглядають публікації, курси й пропозиції в HELFER.',
  'portal.install.online.findSpecialist': 'Знайти спеціаліста',
  'portal.install.online.findSpecialistBody': 'Використовуйте фільтри, відкрийте аватар і перегляньте профіль, курси та відгуки.',
  'portal.install.online.learnMore': 'Докладніше про HELFER',
  'portal.install.online.ios': 'iPhone / App Store',
  'portal.install.online.mac': 'Mac',
  'portal.install.online.windows': 'Windows',
  'portal.install.online.android': 'Android / Google Play',
  'portal.install.online.open': 'Відкрити HELFER online',
  'portal.install.openPortal': 'Відкрити портал',
  'portal.install.close': 'Закрити',
  'desktop.entry.eyebrow': 'Локальний застосунок',
  'desktop.entry.title': 'Ласкаво просимо до системи управління закладом',
  'desktop.entry.body': 'Ви встановили локальний інструмент для роботи кафе або ресторану.',
  'desktop.entry.video.eyebrow': 'Демо-відео',
  'desktop.entry.video.placeholder': 'Коротке демо може швидко показати, як влаштовані управління, розміщення та робочий процес усередині локальної системи.',
  'desktop.entry.video.opened': 'Демо-екран відкрито. Тут можна розмістити локальне навчальне відео або презентаційний ролик для команди.',
  'desktop.entry.login.eyebrow': 'Вхід за ключем',
  'desktop.entry.login.title': 'Увійдіть у робоче середовище',
  'desktop.entry.login.body': 'Введіть ключ доступу та пароль, щоб відкрити локальний застосунок під своєю роллю.',
  'desktop.entry.login.fieldLabel': 'Ключ доступу',
  'desktop.entry.login.placeholder': 'Наприклад, ADMIN-LOCAL-01',
  'desktop.entry.login.submit': 'Увійти',
  'desktop.entry.login.loading': 'Вхід...',
  'desktop.entry.login.qrHint': 'Також можна увійти, відсканувавши персональний QR-код.',
  'desktop.entry.login.error': 'Не вдалося виконати вхід. Перевірте ключ доступу.',
  'desktop.entry.qr.eyebrow': 'QR-вхід',
  'desktop.entry.qr.title': 'Вхід через персональний QR-код',
  'desktop.entry.qr.body': 'Якщо QR-код відкриває застосунок із токеном доступу, вхід виконується автоматично без окремої форми.',
  'desktop.entry.qr.scanTitle': 'Відскануйте QR і відкрийте застосунок',
  'desktop.entry.qr.scanBody': 'Використовуйте посилання виду /login?token=... або app://login?token=..., щоб система одразу ідентифікувала користувача та записала вхід.',
  'desktop.entry.qr.detected': 'Виявлено QR-токен',
  'desktop.start.eyebrow': 'Локальний старт',
  'desktop.start.title': 'Ласкаво просимо',
  'desktop.start.body': 'Оберіть наступний крок.',
  'desktop.start.brand.subtitle': 'Кафе та ресторан',
  'desktop.start.hero.titleLineOne': 'Ласкаво просимо',
  'desktop.start.hero.titleLineTwo': 'до HELFER',
  'desktop.start.hero.body': 'Локальний застосунок для управління вашим кафе або рестораном: замовлення, кухня, персонал і аналітика — усе в одному місці.',
  'desktop.start.hero.enterApp': 'Увійти в застосунок',
  'desktop.start.status.title': 'Застосунок працює локально',
  'desktop.start.status.body': 'Усі дані зберігаються на цьому пристрої',
  'desktop.start.visual.tables': 'Столики',
  'desktop.start.visual.tablesBody': 'Управління столами',
  'desktop.start.visual.orders': 'Замовлення',
  'desktop.start.visual.ordersBody': 'Список замовлень',
  'desktop.start.visual.kitchen': 'Кухня',
  'desktop.start.visual.kitchenBody': 'Екран кухні',
  'desktop.start.visual.staff': 'Персонал',
  'desktop.start.visual.staffBody': 'Управління персоналом',
  'desktop.start.video.eyebrow': 'Демо-екран',
  'desktop.start.video.title': 'Коротке демо',
  'desktop.start.video.placeholder': 'Тут можна тримати коротке знайомство із системою для власника та команди.',
  'desktop.start.video.opened': 'Демо-область активна. Тут можна швидко показати запуск, робочі екрани та сервісний режим.',
  'desktop.start.video.note': 'Допоміжна зона для короткого ролика або локального відео-інструктажу.',
  'desktop.start.video.play': 'Відкрити демо',
  'desktop.start.login.eyebrow': 'Вхід за ключем',
  'desktop.start.login.title': 'Відкрийте локальну систему',
  'desktop.start.login.body': 'Введіть ключ доступу та пароль. QR-вхід залишається доступним окремо.',
  'desktop.start.login.firstAdminEyebrow': 'Перший вхід адміністратора',
  'desktop.start.login.firstAdminKey': 'Ключ',
  'desktop.start.login.firstAdminPassword': 'Пароль',
  'desktop.start.login.fieldLabel': 'Ключ доступу',
  'desktop.start.login.placeholder': 'Наприклад, ADMIN-LOCAL-01',
  'desktop.start.login.passwordLabel': 'Пароль',
  'desktop.start.login.passwordPlaceholder': 'Введіть пароль першого входу',
  'desktop.start.login.submit': 'Увійти',
  'desktop.start.login.loading': 'Вхід...',
  'desktop.start.login.reveal': 'Відкрити вхід',
  'desktop.start.login.hide': 'Приховати вхід',
  'desktop.start.login.qrHint': 'Також можна увійти, відсканувавши персональний QR-код.',
  'desktop.start.login.error': 'Не вдалося виконати вхід. Перевірте ключ доступу.',
  'desktop.start.login.invalidCredentials': 'Невірний ключ доступу або пароль',
  'desktopWelcome.brandSubtitle': 'КАФЕ ТА РЕСТОРАН',
  'desktopWelcome.welcomeLine1': 'Ласкаво просимо',
  'desktopWelcome.welcomeLine2': 'до HELFER',
  'desktopWelcome.description': 'Локальний застосунок для управління вашим кафе або рестораном: замовлення, кухня, персонал і аналітика — усе в одному місці.',
  'desktopWelcome.enterApp': 'Увійти в застосунок',
  'desktopWelcome.localTitle': 'Застосунок працює локально',
  'desktopWelcome.localSubtitle': 'Усі дані зберігаються на цьому пристрої',
  'desktopWelcome.username': 'Ім\'я користувача',
  'desktopWelcome.password': 'Пароль',
  'desktopWelcome.loginEyebrow': 'ВХІД У ЗАСТОСУНОК',
  'desktopWelcome.loginTitle': 'Введіть дані доступу',
  'desktopWelcome.loginSubtitle': 'Введіть ім\'я користувача та пароль, щоб відкрити робочий застосунок.',
  'desktopWelcome.login': 'Увійти',
  'desktopWelcome.forgotPassword': 'Забули пароль?',
  'desktopWelcome.initialSetupEyebrow': 'ПОЧАТКОВЕ НАЛАШТУВАННЯ ДОСТУПУ',
  'desktopWelcome.initialSetupTitle': 'Створіть адміністратора',
  'desktopWelcome.initialSetupSubtitle': 'Задайте дані адміністратора. Після цього співробітники зможуть входити до застосунку за іменем користувача та паролем.',
  'desktopWelcome.adminFullName': 'Повне ім\'я адміністратора',
  'desktopWelcome.repeatPassword': 'Повторіть пароль',
  'desktopWelcome.recoveryCode': 'Ідентифікаційний код відновлення',
  'desktopWelcome.repeatRecoveryCode': 'Повторіть ідентифікаційний код',
  'desktopWelcome.saveAndEnter': 'Зберегти та увійти',
  'desktopWelcome.recoveryTitle': 'Відновлення доступу',
  'desktopWelcome.enterIdentificationCode': 'Введіть ідентифікаційний код',
  'desktopWelcome.createNewPassword': 'Створіть новий пароль',
  'desktopWelcome.repeatNewPassword': 'Повторіть новий пароль',
  'desktopWelcome.recoverAccess': 'Відновити доступ',
  'desktopWelcome.backToSignIn': 'Повернутися до входу',
  'desktopWelcome.recoverySuccess': 'Пароль адміністратора оновлено. Увійдіть з новим паролем.',
  'desktopWelcome.recoveryError': 'Не вдалося відновити доступ',
  'desktopWelcome.recoveryAdminOnly': 'Відновлення пароля доступне лише для адміністратора. Зверніться до адміністратора застосунку.',
  'desktopWelcome.supportRecoveryHint': 'Якщо ви забули і пароль, і ідентифікаційний код, зверніться до підтримки HELFER.',
  'desktopWelcome.fillAllFields': 'Заповніть усі поля',
  'desktopWelcome.passwordsDoNotMatch': 'Паролі не збігаються',
  'desktopWelcome.identificationCodesDoNotMatch': 'Ідентифікаційні коди не збігаються',
  'desktopWelcome.invalidCredentials': 'Невірне ім\'я користувача або пароль',
  'desktopWelcome.bootstrapAccessError': 'Не вдалося відкрити локальний адмін-доступ.',
  'desktopWelcome.loginError': 'Не вдалося виконати вхід.',
  'desktopWelcome.invalidRecoveryCode': 'Невірний ідентифікаційний код',
  'desktopWelcome.recoveryCodeMissing': 'Ідентифікаційний код відновлення не налаштовано. Увійдіть через підтримку HELFER та встановіть новий пароль.',
  'desktopWelcome.userNotFound': 'Користувача не знайдено',
  'desktopWelcome.saveAdministratorError': 'Не вдалося зберегти адміністратора',
  'desktopWelcome.duplicateUsername': 'Користувач із таким ім\'ям вже існує',
  'desktop.start.session.eyebrow': 'Поточна сесія',
  'desktop.start.session.logout': 'Змінити користувача',
  'desktop.start.session.loginType': 'Спосіб входу',
  'desktop.start.session.role': 'Роль',
  'desktop.start.session.loginTime': 'Останній вхід',
  'desktop.start.session.accessKey': 'Ключ доступу',
  'desktop.start.session.loginTypeManual': 'Ключ доступу',
  'desktop.start.session.loginTypeQr': 'QR-код',
  'desktop.start.session.roleAdmin': 'Адміністратор',
  'desktop.start.session.roleKitchen': 'Кухня',
  'desktop.start.session.roleStaff': 'Персонал',
  'desktop.start.session.roleGuest': 'Гість',
  'desktop.start.quick.eyebrow': 'Швидкий старт',
  'desktop.start.quick.title': 'Оберіть наступний крок',
  'desktop.start.quick.body': 'Відкрийте потрібний робочий режим.',
  'desktop.start.quick.primaryEyebrow': 'Основний маршрут',
  'desktop.start.quick.ready': 'Локальна система готова',
  'desktop.start.quick.admin': 'Відкрити адмінку',
  'desktop.start.quick.kitchen': 'Відкрити кухню',
  'desktop.start.quick.tables': 'Відкрити столи',
  'desktop.start.quick.myTable': 'Відкрити мій стіл',
  'desktop.start.quick.qrDemo': 'Відкрити QR-демо столика',
  'desktop.start.qr.eyebrow': 'QR-доступ',
  'desktop.start.qr.title': 'Гостьовий доступ',
  'desktop.start.qr.body': 'Відкрийте посилання для гостьового входу до того самого локального маршруту.',
  'desktop.start.qr.scanTitle': 'QR веде до того самого локального входу',
  'desktop.start.qr.scanBody': 'Гість або співробітник може відкрити застосунок за посиланням із токеном.',
  'desktop.start.qr.detected': 'Виявлено QR-токен',
  'desktop.start.qr.demoEyebrow': 'Гостьовий доступ',
  'desktop.start.qr.demoTitle': 'Гостьове посилання',
  'desktop.start.qr.openGuest': 'Відкрити як гість',
  'desktop.start.qr.copyLink': 'Копіювати посилання',
  'desktop.nav.signOut': 'Вийти',
  'desktop.nav.openPortal': 'Відкрити портал',
  'desktop.nav.backToLocal': 'Назад до локального застосунку',
  'desktop.start.capability.local': 'Конфіденційна локальна робота на комп\'ютері закладу',
  'desktop.start.capability.offline': 'Офлайн та автономна робота за потреби',
  'desktop.start.capability.menu': 'Налаштування меню, вітрини та екранів відображення',
  'desktop.start.capability.tables': 'Обслуговування столиків і сенсорні інструменти',
  'desktop.start.capability.admin': 'Адмін-панель і контроль кухні в одній локальній системі',
  'desktop.start.capability.portal': 'Публічна присутність і рекламний шар порталу',
  'desktop.start.capability.backup': 'Готовність до резервного копіювання та відновлення',
  'desktop.start.capability.qr': 'Продовження замовлення на телефоні через QR',

  // Update banner
  'update.available': 'Доступне оновлення застосунку',
  'update.download': 'Завантажити оновлення',

  // Venue details panel
  'venue.close': 'Закрити',
  'venue.address': 'Адреса',
  'venue.phone': 'Телефон',
  'venue.hours': 'Години роботи',
  'venue.status': 'Статус закладу',
  'venue.open': 'Відчинено',
  'venue.closed': 'Зараз зачинено',
  'venue.occupancy': 'Завантаженість у реальному часі',
  'venue.occupancyDetail': 'Активних столиків із замовленням: {active} з {total}',
  'venue.navigation': 'Навігація',
  'venue.distance': 'Відстань:',
  'venue.openMaps': 'Відкрити в Maps',
  'venue.walking': 'Пішки',
  'venue.driving': 'На автомобілі',
  'venue.showMenu': 'Показати меню',
  'venue.hideMenu': 'Приховати меню',
  'venue.entrancePhotoSoon': 'Фото входу з\'явиться незабаром',
  'venue.menuOnlyLocal': 'Меню доступне лише для підключеного закладу.',
  'venue.menuNoConnection': 'Меню тимчасово недоступне: немає зв\'язку з локальним додатком.',
  'venue.menuClosed': 'Заклад зараз зачинено. Меню недоступне.',
  'venue.reviews': 'Відгуки',
  'venue.reviewAuthorPlaceholder': 'Напишіть ваше ім\'я (необов\'язково)',
  'venue.reviewPlaceholder': 'Напишіть короткий відгук про заклад...',
  'venue.saveReview': 'Зберегти відгук',
  'venue.reportVenue': 'Поскаржитися',
  'venue.reportReview': 'Поскаржитися на відгук',
  'venue.reportTitle': 'Скарга на заклад',
  'venue.reportReviewTitle': 'Скарга на відгук',
  'venue.reportHelp': 'Повідомлення потрапить власнику порталу для перевірки.',
  'venue.reportReason': 'Причина',
  'venue.reportComment': 'Коментар',
  'venue.reportCommentPlaceholder': 'Коротко опишіть проблему',
  'venue.reportContact': 'Контакт для відповіді (необов\'язково)',
  'venue.reportSend': 'Надіслати скаргу',
  'venue.reportSending': 'Надсилаємо...',
  'venue.reportCancel': 'Скасувати',
  'venue.reportSuccess': 'Скаргу надіслано. Дякуємо, ми перевіримо.',
  'venue.reportError': 'Не вдалося надіслати скаргу',
  'venue.reportReason.wrong_location': 'Неправильна локація',
  'venue.reportReason.fake_venue': 'Фейковий заклад',
  'venue.reportReason.offensive_content': 'Образливий контент',
  'venue.reportReason.wrong_menu': 'Неправильне меню',
  'venue.reportReason.wrong_prices': 'Неправильні ціни',
  'venue.reportReason.privacy': 'Персональні дані',
  'venue.reportReason.spam': 'Спам',
  'venue.reportReason.other': 'Інше',

  // Cookie consent banner
  'cookie.dialogLabel': 'Згода на використання файлів cookie',
  'cookie.heading': 'Ми використовуємо файли cookie',
  'cookie.body': 'Необхідні файли cookie забезпечують роботу сайту. Аналітичні файли cookie (Google Analytics) допомагають покращувати сервіс — ми не продаємо ці дані.',
  'cookie.moreInfo': 'Докладніше',
  'cookie.privacy': 'Конфіденційність',
  'cookie.acceptAll': 'Прийняти всі',
  'cookie.necessaryOnly': 'Лише необхідні',

  // Consent text in modals
  'consent.usingService': 'Використовуючи сервіс, ви погоджуєтеся з нашою',
  'consent.installing': 'Встановлюючи застосунок, ви погоджуєтеся з нашою',
  'consent.privacyPolicy': 'Політикою конфіденційності',
  'consent.and': 'та',
  'consent.terms': 'Умовами використання',

  // Legal page navigation & common
  'legal.backToHome': 'На головну',
  'legal.edition': 'Редакція від 17 травня 2025 р. Набирає чинності з дати публікації.',
  'legal.footer': '© 2024–2025 ГО «Центр психологічного та фізичного здоров\'я». HELFER — безкоштовний некомерційний проект.',
  'legal.nav.privacy': 'Конфіденційність',
  'legal.nav.terms': 'Умови використання',
  'legal.nav.cookies': 'Файли cookie',
  'legal.nav.geolocation': 'Геолокація',
  'legal.nav.venueRules': 'Правила закладів',
  'legal.nav.accountDeletion': 'Видалення акаунта',
  'legal.privacy.badge': 'HELFER · ГО «ЦПФЗ»',
  'legal.privacy.title': 'Політика конфіденційності',
  'legal.terms.badge': 'HELFER · ГО «ЦПФЗ»',
  'legal.terms.title': 'Умови використання',
  'legal.cookies.badge': 'HELFER · ГО «ЦПФЗ»',
  'legal.cookies.title': 'Політика файлів cookie та локального сховища',
  'legal.geolocation.badge': 'HELFER · ГО «ЦПФЗ»',
  'legal.geolocation.title': 'Геолокація — навіщо і як',
  'legal.geolocation.subtitle': 'Простою мовою про те, як HELFER використовує геодані.',
  'legal.venueRules.badge': 'HELFER · ГО «ЦПФЗ»',
  'legal.venueRules.title': 'Правила для закладів',
  'legal.venueRules.subtitle': 'Обов\'язково до прочитання перед реєстрацією в HELFER.',
  'portal.footer.free': 'Безкоштовно для всіх.',
  'portal.footer.nonProfit': 'Ми — некомерційний проект (НКО)',

  'locationGuide.title': 'Дозвольте доступ до геолокації',
  'locationGuide.body': 'Для пошуку найближчих закладів порталу потрібен доступ до вашого місцезнаходження. Увімкніть його в налаштуваннях системи.',
  'locationGuide.steps': 'Як дозволити',
  'locationGuide.mac.step1': 'Відкрийте Системні налаштування (меню Apple → Системні налаштування)',
  'locationGuide.mac.step2': 'Перейдіть до «Конфіденційність та безпека»',
  'locationGuide.mac.step3': 'Натисніть «Геолокація»',
  'locationGuide.mac.step4': 'Знайдіть «Cafe Local» у списку та увімкніть перемикач',
  'locationGuide.win.step1': 'Відкрийте Параметри Windows (Win + I)',
  'locationGuide.win.step2': 'Перейдіть до «Конфіденційність та безпека»',
  'locationGuide.win.step3': 'Оберіть «Місцезнаходження»',
  'locationGuide.win.step4': 'Увімкніть «Дозволити програмам доступ до вашого місцезнаходження»',
  'locationGuide.win.step5': 'Переконайтесь, що «Настільні програми» теж увімкнені',
  'locationGuide.linux': 'Переконайтесь, що в налаштуваннях системи дозволено геолокацію для цього застосунку.',
  'locationGuide.openSettings': 'Відкрити налаштування системи',
  'locationGuide.opening': 'Відкриваємо налаштування…',
  'locationGuide.retry': 'Я дозволив — перевірити знову',
  'locationGuide.retrying': 'Перевіряємо…',
  'locationGuide.skip': 'Пропустити — продовжити без геолокації',
  'portal.hero.titleMain': 'Робочі інструменти',
  'portal.hero.titleAccent': 'для вашого бізнесу',
  'portal.hero.body': 'Відкривайте події, робочі сценарії та інструменти Helfer для кафе й ресторанів. Усе зібрано в одному місці й готове до запуску без зайвих налаштувань.',
  'portal.hero.badge': 'Новинка: жива карта закладів — реальні ціни, меню та завантаженість',
  'portal.hero.venuesNearby': '{n} закладів уже на карті — ціни, меню та завантаженість у реальному часі',
  'portal.hero.chip.menu': 'Меню з телефона',
  'portal.hero.chip.storefront': 'Вітрина на вулиці',
  'portal.hero.chip.tools': 'Інструменти залу та кухні',
  'portal.hero.user.titleMain': 'Кафе та ресторани',
  'portal.hero.user.titleAccent': 'на живій карті',
  'portal.hero.user.body': 'Дивіться, де відкрито й наскільки зайнято просто зараз. Меню, відгуки та маршрут — в одному місці.',
  'portal.hero.user.chip.menu': 'Меню та ціни наживо',
  'portal.hero.user.chip.occupancy': 'Завантаженість зараз',
  'portal.hero.user.chip.route': 'Маршрут до місця',
  'portal.hero.business.badge': 'Додайте свій заклад на живу карту — гості поруч побачать вас',
  'portal.controls.userEyebrow': 'ЗНАЙТИ ЗАКЛАД',
  'portal.venue.close': 'Закрити',
  'portal.venue.address': 'Адреса',
  'portal.venue.phone': 'Телефон',
  'portal.venue.hours': 'Час роботи',
  'portal.venue.status': 'Статус',
  'portal.venue.open': 'Відчинено',
  'portal.venue.closed': 'Зараз зачинено',
  'portal.venue.photoSoon': 'Фото входу незабаром з’явиться',
  'portal.venue.occupancy.title': 'Завантаженість у реальному часі',
  'portal.venue.occupancy.detail': 'Активних столиків із замовленням: {ordered} з {active}',
  'portal.venue.occupancy.free': 'Вільно',
  'portal.venue.occupancy.moderate': 'Помірно',
  'portal.venue.occupancy.busy': 'Заповнено',
  'portal.map.legend.title': 'Завантаженість',
  'portal.map.legend.reset': 'Скинути',
  'portal.venue.navigation': 'Навігація',
  'portal.venue.distance': 'Відстань: {value}',
  'portal.venue.openInMaps': 'Відкрити в Maps',
  'portal.venue.walking': 'Пішки',
  'portal.venue.driving': 'Автомобілем',
  'portal.venue.minutes': '{n} хв',
  'portal.venue.showMenu': 'Переглянути меню',
  'portal.venue.hideMenu': 'Сховати меню',
  'portal.venue.reviews': 'Відгуки',
  'portal.venue.reviewsCount': 'Відгуки ({n})',
  'portal.venue.hideReviews': 'Сховати відгуки',
  'portal.venue.menu': 'Меню',
  'portal.venue.itemsCount': '{n} поз.',
  'portal.venue.allCategories': 'Усі',
  'portal.venue.noItems': 'У цій категорії поки немає страв.',
  'portal.venue.noReviews': 'Поки що відгуків немає.',
  'portal.venue.leaveReview': 'Залишити відгук',
  'portal.venue.reviewPlaceholder': 'Напишіть короткий відгук про заклад',
  'portal.venue.saveReview': 'Зберегти відгук',
  'portal.venue.guestAuthor': 'Гість порталу',
  'portal.venue.uncategorized': 'Без категорії',
  'portal.venue.unit.m': 'м',
  'portal.venue.unit.km': 'км',
  'portal.venue.day.mon': 'Пн',
  'portal.venue.day.tue': 'Вт',
  'portal.venue.day.wed': 'Ср',
  'portal.venue.day.thu': 'Чт',
  'portal.venue.day.fri': 'Пт',
  'portal.venue.day.sat': 'Сб',
  'portal.venue.day.sun': 'Нд',
  'desktopWelcome.qrCardScanHint': 'Відскануйте телефоном у тій самій мережі',
  'desktopWelcome.qrCardOr': 'або',

  // Billing / subscription
  'billing.back': 'Назад в адмінку',
  'billing.title': 'Підписка та платежі',
  'billing.subtitleTemplate': 'Базова робота кафе безкоштовна: до {tables} столиків і {menuItems} страв у меню. Підписка «{plan}» знімає обидва обмеження — додавайте столики та страви без ліміту.',
  'billing.success.title': 'Оплата пройшла успішно 🎉',
  'billing.success.body': 'Підписка активується протягом кількох секунд. Чек надійде на вашу пошту від Stripe.',
  'billing.canceled': 'Оплату скасовано. Ви можете спробувати знову будь-якої миті.',
  'billing.status.title': 'Поточний статус',
  'billing.plan': 'Тариф',
  'billing.free': 'Безкоштовний',
  'billing.billingCycle': 'Період оплати',
  'billing.year': 'Рік',
  'billing.month': 'Місяць',
  'billing.activeUntil': 'Діє до',
  'billing.nextCharge': 'Наступне списання',
  'billing.email': 'Пошта',
  'billing.tables': 'Столики',
  'billing.menuItems': 'Страви в меню',
  'billing.opening': 'Відкриваємо…',
  'billing.manage': 'Керувати підпискою / скасувати',
  'billing.subscribeTitle': 'Оформити підписку «{plan}»',
  'billing.cycleMonthly': 'Місяць',
  'billing.cycleYearly': 'Рік · 2 місяці у подарунок',
  'billing.emailLabel': 'Email для чека та доступу',
  'billing.preparing': 'Готуємо оплату…',
  'billing.checkout': 'Перейти до оплати',
  'billing.unavailable': 'Оплата тимчасово недоступна: платіжна система ще налаштовується на сервері.',
  'billing.stripeNote': 'Оплата проходить на захищеній сторінці Stripe. Скасувати підписку можна будь-коли в кабінеті Stripe.',
  'billing.history.title': 'Історія платежів',
  'billing.history.empty': 'Поки немає жодної оплати.',
  'billing.history.date': 'Дата',
  'billing.history.plan': 'Тариф',
  'billing.history.period': 'Період',
  'billing.history.email': 'Пошта',
  'billing.history.status': 'Статус',
  'billing.statusLabel.free': 'Безкоштовний',
  'billing.statusLabel.active': 'Активна',
  'billing.statusLabel.trialing': 'Пробний період',
  'billing.statusLabel.past_due': 'Очікує оплату',
  'billing.statusLabel.unpaid': 'Не оплачено',
  'billing.statusLabel.incomplete': 'Не завершено',
  'billing.statusLabel.canceled': 'Скасована',
  'billing.checkoutStatus.paid': 'Оплачено',
  'billing.checkoutStatus.failed': 'Помилка',
  'billing.checkoutStatus.cancelled': 'Скасовано',
  'billing.checkoutStatus.pending': 'Очікує',
  'billing.error.load': 'Не вдалося завантажити статус підписки.',
  'billing.error.email': 'Вкажіть коректний email.',
  'billing.error.noUrl': 'Сервер не повернув посилання на оплату.',
  'billing.error.checkout': 'Не вдалося створити оплату.',
  'billing.error.portal': 'Не вдалося відкрити кабінет Stripe.',
  // Admin extra strings
  'admin.limit.title': 'Досягнуто ліміт безкоштовного тарифу',
  'admin.limit.detail': 'Вже додано: {current} з {limit} {unit} на безкоштовному тарифі.',
  'admin.limit.tablesWord': 'столиків',
  'admin.limit.dishesWord': 'страв',
  'admin.limit.subscribe': 'Оформити підписку',
  'admin.limit.later': 'Пізніше',
  'admin.build': 'Збірка',
  'admin.billingButton': 'Підписка та платежі',
  'admin.today': 'Сьогодні',
  'admin.ordersHint': 'На головній сторінці показуються замовлення поточного робочого дня. Історія замовлень — в окремій вкладці:',
  'admin.salesStats': 'Статистика продажів',
  'admin.staffPin.title': 'PIN-коди офіціантів',
  'admin.staffPin.subtitle': 'Встановіть 4-значний PIN для кожного офіціанта',
  'admin.staffPin.invalid': 'PIN має бути 4 цифри',
  'admin.staffPin.saved': 'PIN збережено',
  'admin.save': 'Зберегти',
  'admin.error': 'Помилка',
  'admin.connectionError': 'Помилка з\'єднання',
  'admin.staffAnalytics.eyebrow': 'Аналітика',
  'admin.staffAnalytics.title': 'Аналітика офіціантів',
  'admin.staffAnalytics.name': 'Ім\'я',
  'admin.staffAnalytics.orders': 'Замовлень',
  'admin.staffAnalytics.tables': 'Столиків',
  'admin.staffAnalytics.lastOrder': 'Останнє замовлення',
  'admin.phoneHint': 'Введіть номер з кодом країни, щоб на порталі за ним можна було зателефонувати.',
  'admin.venueEmail': 'Email закладу',
  'admin.geo.error': 'Геолокація: помилка',
  'admin.geo.syncSkipped': 'синхронізація не налаштована',
  'admin.geo.syncError': 'помилка синхронізації',
  'admin.geo.apiError': 'API: помилка',

  // Profit Assistant — Ingredients
  'costing.ingredients.label': 'Довідник',
  'costing.ingredients.title': 'Інгредієнти',
  'costing.ingredients.add': 'Додати інгредієнт',
  'costing.ingredients.search': 'Пошук інгредієнтів...',
  'costing.ingredients.allUnits': 'Усі одиниці',
  'costing.ingredients.empty': 'Немає інгредієнтів',
  'costing.ingredients.name': 'Назва',
  'costing.ingredients.unit': 'Одиниця',
  'costing.ingredients.packageSize': 'Розмір упаковки',
  'costing.ingredients.packagePrice': 'Ціна',
  'costing.ingredients.unitCost': 'Вартість за одиницю',
  'costing.ingredients.supplier': 'Постачальник',
  'costing.ingredients.actions': 'Дії',
  'costing.ingredients.addNew': 'Додати інгредієнт',
  'costing.ingredients.edit': 'Редагувати',
  'costing.ingredients.save': 'Зберегти',
  'costing.ingredients.saving': 'Збереження...',
  'costing.ingredients.cancel': 'Скасувати',
  'costing.ingredients.currency': 'Валюта',
  'costing.ingredients.noSupplier': 'Немає постачальника',
  'costing.ingredients.calculatedCost': 'Розрахункова вартість за одиницю',
  'costing.ingredients.loadError': 'Помилка завантаження інгредієнтів',
  'costing.ingredients.saveError': 'Помилка збереження інгредієнта',
  'costing.ingredients.deleteError': 'Помилка видалення інгредієнта',
  'costing.ingredients.confirmDelete': 'Видалити цей інгредієнт?',
  'costing.ingredients.priceHistory': 'Історія цін',
  'costing.ingredients.noPriceHistory': 'Історії цін немає',
  'costing.ingredients.close': 'Закрити',

  'costing.recipes.label': 'Рецепти',
  'costing.recipes.title': 'Редактор рецептів',
  'costing.recipes.selectDish': 'Оберіть страву',
  'costing.recipes.selectDishHint': 'Оберіть страву для редагування рецепту',
  'costing.recipes.ingredients': 'Інгредієнти',
  'costing.recipes.noIngredients': 'Немає інгредієнтів у рецепті',
  'costing.recipes.ingredient': 'Інгредієнт',
  'costing.recipes.quantity': 'Кіл-во',
  'costing.recipes.unit': 'Одиниця',
  'costing.recipes.waste': 'Відходи %',
  'costing.recipes.unitCost': 'Ціна/одиниця',
  'costing.recipes.lineCost': 'Вартість рядка',
  'costing.recipes.actions': 'Дії',
  'costing.recipes.selectIngredient': 'Оберіть інгредієнт...',
  'costing.recipes.addLine': 'Додати',
  'costing.recipes.recipeCost': 'Вартість рецепту',
  'costing.recipes.dishPrice': 'Ціна страви',
  'costing.recipes.foodCost': 'Собівартість %',
  'costing.recipes.ofPrice': '% від ціни',
  'costing.recipes.profit': 'Прибуток на одиницю',
  'costing.recipes.margin': '% маржа',
  'costing.recipes.unsavedChanges': 'Є незбережені зміни',
  'costing.recipes.discard': 'Скасувати',
  'costing.recipes.save': 'Зберегти рецепт',
  'costing.recipes.saving': 'Збереження...',
  'costing.recipes.saveError': 'Помилка збереження рецепту',
  'costing.recipes.loadError': 'Помилка завантаження рецепту',

  'costing.assistant.label': 'Помічник прибутку',
  'costing.assistant.title': 'Аналіз прибутковості',
  'costing.assistant.loading': 'Завантаження...',
  'costing.assistant.refresh': 'Оновити',
  'costing.assistant.insufficientData': 'Недостатньо даних для аналізу',
  'costing.assistant.revenue': 'Виручка',
  'costing.assistant.units': 'Продано одиниць',
  'costing.assistant.cogs': 'Собівартість',
  'costing.assistant.profit': 'Валовий прибуток',
  'costing.assistant.coverage': 'Покриття розрахунків',
  'costing.assistant.matrix': 'Матриця меню (BCG)',
  'costing.assistant.stars': 'Зірки — популярно, прибутково',
  'costing.assistant.plowhorses': 'Робочі коні — популярно, низький прибуток',
  'costing.assistant.puzzles': 'Загадки — непопулярно, прибутково',
  'costing.assistant.dogs': 'Собаки — непопулярно, низький прибуток',
  'costing.assistant.noItems': 'Немає позицій у цій категорії',
  'costing.assistant.dishes': 'Усі страви',
  'costing.assistant.noDishes': 'Немає страв з продажами',
  'costing.assistant.name': 'Страва',
  'costing.assistant.sold': 'Продано',
  'costing.assistant.cost': 'Вартість',
  'costing.assistant.margin': 'Маржа',
  'costing.assistant.foodCost': 'Соб. %',
  'costing.assistant.recommendations': 'Рекомендації',
  'costing.assistant.loadError': 'Помилка завантаження аналітики',
  'costing.assistant.heroTitle': 'Збільшуйте прибуток з кожної страви',
  'costing.assistant.heroDesc': 'Дивіться реальну собівартість, знаходьте найприбутковіші позиції та отримуйте рекомендації, які страви варто просувати, покращити або видалити з меню.',
  'costing.assistant.heroCta': 'Перевірте, які страви приносять вам гроші',
};
